import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    ordenTrabajo: {},

    id: 0,
    cliente: '',
    accion: '',
    rubroTrabajoId: 0,
    rubroTrabajo: null,
    rubroTrabajoNombre: null,
    rubroTrabajoDescripcion: '',
    categoriaServicioId: 0,
    categoriaServicio: null,
    categoriaServicioNombre: null,
    titulo: '',
    pjeRentabilidadMinima: 0,
    premios: false,
    reembolsos: false,
    noAplicaFee: false,
    excluidoComisiones: false,
    descripcion: '',
    cantidad: 0,
    monedaId: 0,
    moneda: null,
    monedaNombre: null,
    costoEstimado: 0,
    costoEstimadoTotal: 0,
    costoUnitario: false,
    costoInterno: 0,
    pjeRentabilidad: 0,
    /* Parámetros para el cálculo del costo interno */
    parametrosGlobales: true,
    pjeGastosFijos: 0,
    pjeInversionFutura: 0,
    pjeImpuestosInternos: 0,
    rowVersion: null,
    
    imagenes: [],

    pjeRentabilidadOriginal: 0,
    /* Parametro general */
    pjeRentabilidadParametro: parseFloat(35),
    /* Vista de datos de una orden */
    ordenDatos: [],

    readOnly: false,
    rubros: [],
    rubrosList: [],

    /* Parametros */
    clienteId: 0,
    discriminarCategoriaServicio: false,

    descripcionGpt: '',
    transcriptionGpt: '',
    completionGpt: ''
};

const mutations = {
    updateField,

    'INICIALIZAR_ORDEN' (state, params) {
        state.ordenTrabajo = {};

        state.cliente = '';
        state.accion = '';
        state.rubroTrabajoId = 0;
        state.rubroTrabajo = null;
        state.rubroTrabajoNombre = null;
        state.rubroTrabajoDescripcion = '';
        state.categoriaServicioId = 0;
        state.categoriaServicio = null;
        state.categoriaServicioNombre = null;
        state.titulo = '';
        state.pjeRentabilidadMinima = 0;
        state.premios = false;
        state.reembolsos = false;
        state.noAplicaFee = false;
        state.excluidoComisiones = false;
        state.descripcion = '';
        state.cantidad = 0;
        // state.monedaId = 0;
        // state.moneda = null;
        // state.monedaNombre = null;
        state.monedaId = 101;
        state.moneda = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';
        state.costoEstimado = 0;
        state.costoEstimadoTotal = 0;
        state.costoUnitario = false;
        state.pjeRentabilidad = 0;
        /* Parámetros para el cálculo del costo interno */
        state.parametrosGlobales = true;
        state.pjeGastosFijos = 0;
        state.pjeInversionFutura = 0;
        state.pjeImpuestosInternos = 0;
        state.rowVersion = null;
        
        state.readOnly = false;
        state.pjeRentabilidadOriginal = 0;

        if (params) {
            state.discriminarCategoriaServicio = (/true/i).test(params.discriminarCategoriaServicio);

            if (params.clienteId) {
                state.clienteId = parseInt(params.clienteId);
            }

        } else {
            state.discriminarCategoriaServicio = false;
            state.clienteId = 0;
        }

        state.imagenes = [];
    },
    'ID' (state, id) {
        state.id = id;
    },
    'SET_PARAMETROS' (state, params) {
        state.pjeRentabilidadParametro = params.pjeMargenOrdenTrabajo;
    },
    'SET_ORDEN' (state, orden) {
        // console.log(orden);
        state.ordenTrabajo = orden;
        state.cliente = ''; //orden.cliente.trim();
        state.accion = ''; //orden.accion.trim();
        state.rubroTrabajoId = orden.rubroTrabajo? orden.rubroTrabajo.id : 0;
        state.rubroTrabajo = orden.rubroTrabajo;
        state.rubroTrabajoNombre = orden.rubroTrabajo? orden.rubroTrabajo.nombre.trim() : null;
        state.rubroTrabajoDescripcion = orden.rubroTrabajo? orden.rubroTrabajo.descripcion.trim() : null;
        state.categoriaServicioId = orden.categoriaServicio? orden.categoriaServicio.id : 0;
        state.categoriaServicio = orden.categoriaServicio;
        state.categoriaServicioNombre = orden.categoriaServicio? orden.categoriaServicio.nombre.trim() : null;
        state.titulo = orden.titulo.trim();
        state.pjeRentabilidadMinima = parseFloat(orden.pjeRentabilidadMinima);
        state.premios = (/true/i).test(orden.premios);
        state.reembolsos = (/true/i).test(orden.reembolsos);
        state.noAplicaFee = (/true/i).test(orden.noAplicaFee);
        state.excluidoComisiones = (/true/i).test(orden.excluidoComisiones);
        state.descripcion = orden.descripcion.trim();
        state.cantidad = parseFloat(orden.cantidad);
        state.monedaId = orden.moneda? orden.moneda.id : 0;
        state.moneda = orden.moneda;
        state.monedaNombre = orden.moneda? orden.moneda.nombre.trim() : null;
        state.costoEstimado = parseFloat(orden.costoEstimado);
        state.costoEstimadoTotal = parseFloat(orden.costoEstimadoTotal);
        state.costoUnitario = orden.costoUnitario;
        state.pjeRentabilidad = parseFloat(orden.pjeRentabilidad);
        /* Parámetros para el cálculo del costo interno */
        state.parametrosGlobales = Boolean(orden.parametrosGlobales);
        state.pjeGastosFijos = parseFloat(orden.pjeGastosFijos);
        state.pjeInversionFutura = parseFloat(orden.pjeInversionFutura);
        state.pjeImpuestosInternos = parseFloat(orden.pjeImpuestosInternos);
        state.rowVersion = orden.rowVersion;
        
        state.readOnly = (/true/i).test(orden.certificado);
        state.pjeRentabilidadOriginal = parseFloat(orden.pjeRentabilidad);
    },
    'SET_ORDEN_TRABAJO'(state, orden) {
        state.ordenTrabajo = orden;
    },
    'SET_RUBRO_TRABAJO'(state, rubro) {
        let loadRubro = false;
        if (rubro) {
            loadRubro = true;
        }

        if (loadRubro) {

            if (rubro.id != state.rubroTrabajoId) {
                state.rubroTrabajoId= rubro.id;
                state.rubroTrabajo = rubro;
                state.rubroTrabajoNombre= rubro.nombre.trim();
                state.rubroTrabajoDescripcion= rubro.descripcion.trim();
        
                state.pjeRentabilidad = parseFloat(state.pjeRentabilidadParametro);
                state.pjeRentabilidadMinima = parseFloat(rubro.pjeMargenMinimo);
                state.premios = (/true/i).test(rubro.premios);
                state.reembolsos = (/true/i).test(rubro.reembolsos);
                state.noAplicaFee = (/true/i).test(rubro.noAplicaFee);
                state.excluidoComisiones = (/true/i).test(rubro.excluidoComisiones);

                /* Parámetros para el cálculo del costo interno */
                state.parametrosGlobales = (/true/i).test(rubro.parametrosGlobales);
                state.pjeGastosFijos = parseFloat(rubro.pjeGastosFijos);
                state.pjeInversionFutura = parseFloat(rubro.pjeInversionFutura);
                state.pjeImpuestosInternos = parseFloat(rubro.pjeImpuestosInternos);
            }
        } else {
            state.rubroTrabajoId= 0;
            state.rubroTrabajo = rubro;
            state.rubroTrabajoNombre= null;
            state.rubroTrabajoDescripcion= '';
    
            state.pjeRentabilidad = 0;
            state.pjeRentabilidadMinima = 0;
            state.premios = false;
            state.reembolsos = false;
            state.noAplicaFee = false;
            state.excluidoComisiones = false;

            /* Parámetros para el cálculo del costo interno */
            state.parametrosGlobales = true;
            state.pjeGastosFijos = 0;
            state.pjeInversionFutura = 0;
            state.pjeImpuestosInternos = 0;
        }
    },
    'SET_CATEGORIA_SERVICIO'(state, categoriaServicio) {
        state.categoriaServicio = categoriaServicio;
        if (categoriaServicio) {
            state.categoriaServicioId= categoriaServicio.id? categoriaServicio.id : 0;
            state.categoriaServicioNombre= categoriaServicio.nombre? categoriaServicio.nombre.trim() : null;
        } else {
            state.categoriaServicioId= 0;
            state.categoriaServicioNombre= null;
        }
    },
    'CALCULAR_COSTO_UNITARIO'(state) {
        if (state.cantidad != 0) {
            state.costoEstimado = helpers.methods.roundToTwo(state.costoEstimadoTotal / state.cantidad);
        } else {
            state.costoEstimado = 0;
        }
    },
    'CALCULAR_COSTO_TOTAL'(state) {
        state.costoEstimadoTotal = helpers.methods.roundToTwo(state.costoEstimado * state.cantidad);
    },
    'SET_MONEDA'(state, moneda) {
        state.moneda = moneda;
        if (moneda) {
            state.monedaId = moneda.id? moneda.id : 0;
            state.monedaNombre = moneda.nombre? moneda.nombre.trim() : null;
        } else {
            state.monedaId = 0;
            state.monedaNombre = null;
        }
    },

    'SET_RUBROSTRABAJOS'(state, params) {
        state.rubros = params.rubros;
        state.rubrosList = params.rubrosList;
        
        /* Verificamos si el rubro esta incluido en la lista (si no fue inactivado) */
        if (state.rubroTrabajoId != 0)
        {
            let index = state.rubros.findIndex(r => r.id == state.rubroTrabajoId);
            if (index == -1) {
                state.rubros.push({
                    id: state.rubroTrabajoId,
                    nombre: state.rubroTrabajoNombre.trim(),
                    descripcion: state.rubroTrabajoDescripcion.trim(),
                    pjeRentabilidadMinima: state.pjeRentabilidadMinima,
                    premios: state.premios,
                    reembolsos: state.reembolsos,
                    noAplicaFee: state.noAplicaFee,
                    excluidoComisiones: state.excluidoComisiones
                });

                state.rubrosList.push(state.rubroTrabajoNombre.trim());

                state.rubrosList.sort();
            }
        }
    },

    'SET_IMAGENES' (state, imagenes) {
        state.imagenes = imagenes;
    },
    'ADD_IMAGEN' (state, imagen) {
        state.imagenes.push(imagen);
    },
    'REMOVE_IMAGEN' (state, imagenId) {
        let itemKey = state.imagenes
            .findIndex(imagen => imagen.id == imagenId);

        if (itemKey != -1) {
            state.imagenes.splice(itemKey, 1);
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.ordenDatos = [];
    },
    'SET_DATOS' (state, params) {
        state.ordenDatos = params.ordenDatos;
    },

    'INICIALIZAR_GPT' (state) {
        state.descripcionGpt = '';
    },
    'SET_GPT_RESPONSE' (state, gptResponse) {
        state.descripcionGpt = gptResponse.response;
    },    
    'INICIALIZAR_TRANSCRIPTION_GPT' (state) {
        state.transcriptionGpt = '';
        state.completionGpt = '';
    },
    'SET_TRANSCRIPTION_GPT' (state, gptResponse) {
        state.transcriptionGpt = gptResponse.transcription;
        state.completionGpt = gptResponse.completion;
    },    
};

const getters = {
    getField,

    getOrdenTrabajo (state) {
        return state.ordenTrabajo;
    },

    descripcionGpt (state) {
        return state.descripcionGpt;
    },
    transcriptionGpt (state) {
        return state.transcriptionGpt;
    },
    completionGpt (state) {
        return state.completionGpt;
    }
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDEN', params);

            let getOrden = false;
            if (params) {
                if (params.orden) {
                    getOrden = true;
                }
            }

            if (getOrden) {
                commit('SET_ORDEN', params.orden);
                resolve();
            } else {
                /* Recuperamos el margen inicial (parametro general) */
                apiAxios.get('ordenestrabajos/parametros' ) 
                    .then(res => {
                        commit('SET_PARAMETROS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let item = {
                rubroTrabajoId: state.rubroTrabajoId, 
                rubroTrabajo: state.rubroTrabajo,
                categoriaServicioId: state.categoriaServicioId, 
                categoriaServicio: state.categoriaServicio,
                titulo: state.titulo.toUpperCase().trim(),
                pjeRentabilidadMaxima: 0, //state.pjeRentabilidadMaxima,
                pjeRentabilidadMinima: state.pjeRentabilidadMinima,
                premios: (/true/i).test(state.premios),
                reembolsos: (/true/i).test(state.reembolsos),
                noAplicaFee: (/true/i).test(state.noAplicaFee),
                excluidoComisiones: (/true/i).test(state.excluidoComisiones),
                descripcion: state.descripcion.trim(), 
                cantidad: parseInt(state.cantidad),
                monedaId: parseInt(state.monedaId),
                moneda: state.moneda,
                costoEstimado: parseFloat(state.costoEstimado),
                costoEstimadoTotal: parseFloat(state.costoEstimadoTotal),
                costoUnitario: (/true/i).test(state.costoUnitario),
                pjeRentabilidad: parseFloat(state.pjeRentabilidad),
                /* Parámetros para el cálculo del costo interno */
                parametrosGlobales: (/true/i).test(state.parametrosGlobales),
                pjeGastosFijos: parseFloat(state.pjeGastosFijos),
                pjeInversionFutura: parseFloat(state.pjeInversionFutura),
                pjeImpuestosInternos: parseFloat(state.pjeImpuestosInternos),
                rowVersion: state.rowVersion
            }
            commit('SET_ORDEN_TRABAJO', item);
            resolve()
        })
    },

    getRubrosTrabajos: ( { commit, state, dispatch, rootState } ) => {
        return new Promise((resolve, reject) => {
            /* Recuperamos la info de rubros de trabajo del cliente */
            dispatch('rubrostrabajos/getRubrosClienteList', state.clienteId, {root: true})
                .then(() => {
                    let params = {
                        rubros: rootState.rubrostrabajos.rubrosList,
                        rubrosList: rootState.rubrostrabajos.rubrosSelectList
                    }
                    commit('SET_RUBROSTRABAJOS', params);
                    resolve();
        
                })
                .catch(() => {
                    reject('Se produjo un error al recuperar la información de rubros de trabajo.');
                })
        })
    },

    setRubroTrabajo: ( {commit }, rubroTrabajo) => {
        return new Promise((resolve, reject) => {
            commit('SET_RUBRO_TRABAJO', rubroTrabajo);
            resolve();
        })
    },
    setCategoriaServicio: ( {commit }, categoriaServicio) => {
        return new Promise((resolve, reject) => {
            commit('SET_CATEGORIA_SERVICIO', categoriaServicio);
            resolve();
        })
    },
    setMoneda: ( {commit }, moneda) => {
        return new Promise((resolve, reject) => {
            commit('SET_MONEDA', moneda);
            resolve();
        })
    },
    calcularCostoUnitario: ( {commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_UNITARIO');
            resolve();
        })
    },
    calcularCostoTotal: ( {commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_TOTAL');
            resolve();
        })
    },

    getImagenes: ( { commit }, params ) => {
        return new Promise((resolve, reject) => {
            apiAxios.get(`ordenestrabajos/${params.ordenTrabajoId}/imagenes` ) 
                .then(res => {
                    commit('SET_IMAGENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addImagen ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            let error;
            let fileName = params.file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(params.file.size / 1048576);

            if (fileExtension != 'jpg' 
                & fileExtension != 'png'
                & fileExtension != 'jpeg') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten imágenes de tipo jpg, png o jpeg.';
            }

            if (fileSize >= 0.3 ) {
                error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes de hasta 300KB.';
            }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', params.file);
				formData.append('main', params.main);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

				apiAxios.post(`ordenestrabajos/${params.ordenTrabajoId}/imagenes`, formData, options)
                    .then(res => {
                        commit('ADD_IMAGEN', res.data);
                        resolve();
                    })
					.catch(error => reject(helpers.methods.getErrorMessage(error)));
			}
        })
    },	
    removeImagen ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`ordenestrabajos/${params.ordenTrabajoId}/imagenes/${params.imagenId}/delete`)
                .then(() => {
					commit('REMOVE_IMAGEN', params.imagenId);
					resolve();
				})
				.catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    askGpt: ( { commit, state }, rubroTrabajoId ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_GPT');

            apiAxios.get(`ordenestrabajos/rubros/${rubroTrabajoId}/ask-completion?observaciones='${state.descripcion}'`)
                .then(res => {
					commit('SET_GPT_RESPONSE', res.data);
					resolve();
				})
				.catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    askTranscription: ( { commit, state }, file ) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TRANSCRIPTION_GPT');

            const formData = new FormData();
            formData.append('file', file);

            let options = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

            apiAxios.post(`ordenestrabajos/ask-transcription`, formData, options)
                .then(res => {
					commit('SET_TRANSCRIPTION_GPT', res.data);
					resolve();
				})
				.catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}